var nurseslounge_myDashboard_thoughtLeadersForm = {
    init:function($params){
        $("#topNav .thoughtLeaders-form").unbind().click(function(){
            nurseslounge_myDashboard_thoughtLeadersForm.open_modal($params);
        });
    },
    open_modal:function($params){
        var $modal = $("#nurseslounge-lounge-thought-leaders-modal");
        nurseslounge_myDashboard_thoughtLeadersForm.popup_form($params, function($chtml){
            $modal.find('.modal-body').html($chtml).promise().done(function(){
                nurseslounge_myDashboard_thoughtLeadersForm.popup_form_events($params, function(){
                    $modal.modal('show');
                });
            });
        });
    },
    popup_form:function($params, cback){
        $.ajax({
            url: "/myDashboard/header/thoughtLeaders/popup",
            method: "POST",
            cache:false,
            dataType: "html",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    popup_form_events:function($params, cback){
        nurseslounge_myDashboard_thoughtLeadersForm.popup_form_validate(function($form){
            nurseslounge_myDashboard_thoughtLeadersForm.popup_form_request($.extend({}, $params ,libs.getObjForm($form)), function(){
                $("#nurseslounge-lounge-thought-leaders-modal").modal('hide');
            });
        });
        if(cback != undefined){
            cback();
        }
    },
    popup_form_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-lounge-thought-leaders-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-lounge-thought-leaders-modal form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                name: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                },
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                },
                linkedin: {
                    required: false,
                    minlength: 3
                },
                expertise: {
                    required: false,
                    minlength: 3,
                    maxlength: 191,
                },
                thoughtLeader: {
                    required: true,
                    minlength: 3,
                }
            },
            messages: {
                name: {
                    required: "The name is required",
                    minlength: "The name must have at least 3 characters",
                    maxlength: "The name cannot exceed 191 characters"
                },
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                },
                linkedin: {
                    required: "The linkedin link is not required",
                    minlength: "The email must have at least 3 characters",
                },
                expertise: {
                    required: "The area of expertise is not required",
                    minlength: "The name must have at least 3 characters",
                    maxlength: "The name cannot exceed 191 characters"
                },
                thoughtLeader: {
                    required: "The thought leader is required",
                    minlength: "The email must have at least 3 characters",
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    popup_form_request:function($data, cback){
        $.ajax({
            url:"/myDashboard/header/thoughtLeaders/popup/set",
            method: "POST",
            dataType: "json",
            data:$data,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    cback();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                //alert(errorThrown);
            }
        });
    }
};
